import React, { ReactNode, useCallback } from "react"
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, RadioGroupProps, FormHelperText } from "@material-ui/core"
import { LookupItemType } from "../models/lookupTypes"
import { useStyles } from "../pages/styled"
import theme from "../theme"
import { useGa4Context } from "../context/Ga4Context"
import useGa4 from "../hooks/useGa4"

export type RadioButtonsFieldProps = RadioGroupProps & {
  label?: ReactNode
  lookup: LookupItemType[]
  required?: boolean
  error?: boolean
  helperText?: ReactNode
}
export const RadioButtonsField = (props: RadioButtonsFieldProps) => {
  const { label, required, error, lookup, helperText, onFocus, ...rest } = props

  const classes = useStyles(theme)
  const ga4Data = useGa4Context().ga4Data
  const { ga4_formFieldClick } = useGa4()
  
  const handleFocus = useCallback(
    (e: any) => {
      ga4_formFieldClick({ case_type: ga4Data?.case_type, step: ga4Data?.step, form_name: ga4Data?.form_name, field_name: props.name })
      if (onFocus !== undefined) {
        onFocus(e)
      }
    }, [ga4_formFieldClick, ga4Data, props.name, onFocus]
  )
  return (
    <FormControl component="fieldset">
      <FormLabel
        required={required}
        error={error}
      >
        {label}
      </FormLabel>
      <RadioGroup
        onFocus={handleFocus}
        className={classes.radioButtons}
        {...rest}
      >
        {lookup.map((item, index) =>
          <FormControlLabel
            key={index}
            value={item.code}
            control={<Radio />}
            label={item.name}
          />
        )}
      </RadioGroup>
      {helperText != null && helperText !== '' && (
        <FormHelperText error={error} style={{ marginTop: 0 }}>
          {props.helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

/* TODO: do CA
    {params.caseType === 'CA' && (
      <QuestionMark
        text={t('tripForm.travelType.questionMarkLabel')}
        height={20}
      />
    )}
*/

